import Vue from 'vue/dist/vue.esm'
import ReturnableOrders from 'components/storefront/returnable-orders'

export default function buildReturnableOrders(element) {
  new Vue({
    el: element,
    components: {
      ReturnableOrders
    }
  })
}
